import React from 'react';
import Box from '@mui/material/Box';
import Profile from './Profile';
import Education from './Education';
import AcademicProjects from './AcademicProjects';
import WorkExperience from './WorkExperience_';
import MoreAboutMe from './MoreAboutMe';
import Skills from './Skills';
import Certifications from './Certifications';

const mainBoxStyle = {
  backgroundImage: `url('/keyboard-coffee.jpg')`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundAttachment: 'fixed',
  display: 'flex',
    height: '100vh',
  flex: 1
};

const MainContent: React.FC<{ location: any; isSidebarOpen: boolean; setIsSidebarOpen: (isOpen: boolean) => void }> = ({ location, isSidebarOpen, setIsSidebarOpen }) => {
    
    const renderComponent = () => {
    switch (location.pathname) {
      case '/':
            return <Profile isSidebarOpen={isSidebarOpen}/>;
      case '/education':
        return <Education isSidebarOpen={isSidebarOpen}/>;
      case '/academic-projects':
        return <AcademicProjects isSidebarOpen={isSidebarOpen}/>;
      case '/work-experience':
        return <WorkExperience isSidebarOpen={isSidebarOpen}/>;
      case '/more-about-me':
        return <MoreAboutMe />;
      case '/skills':
        return <Skills />;
      case '/certifications':
        return <Certifications isSidebarOpen={isSidebarOpen}/>;
      default:
        return <Profile isSidebarOpen={isSidebarOpen}/>;
    }
  };

  return (
      <Box component="main" sx={mainBoxStyle}>
          {renderComponent()}
    </Box>
  );
};

export default MainContent;

